// extracted by mini-css-extract-plugin
var _1 = "List-zN3FG";
var _2 = "SearchResultsItem-RZNaQ";
export { _1 as "List", _2 as "SearchResultsItem" }
